const Footer = () => {
  return (
    <footer className="footer">
      <h6>&#169; jimsnelgrove.com</h6>
    </footer>
  )
}

export default Footer
